import { render, staticRenderFns } from "./list-task.vue?vue&type=template&id=3358bb3c&scoped=true"
import script from "./list-task.vue?vue&type=script&lang=js"
export * from "./list-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3358bb3c",
  null
  
)

export default component.exports